import axios from "axios";
import {API_URL} from "@env";

export const getMemberCredits = (memberId) => {
    return axios.get(API_URL + `/member_credits/${memberId}`);
}